import { HelpOutlined } from "@mui/icons-material";
import { Paper } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import HelpMenu from "../help-menu/HelpMenu";
import { AdministrationListItem } from "./AdministrationListItem";
import { routes } from "../../routes/routes";
import AdministrationListUtils from "./AdministrationListUtils";

export type AdministrationListProps = {
    viewIDs: UIViewEnum[]
};

export function AdministrationList({
    viewIDs
}: AdministrationListProps) {

    const [helpOpen, setHelpOpen] = useState(false);

    const { t } = useTranslation();


    //console.log(`adminlist viewIDs: ${JSON.stringify(viewIDs)}`);


    const items = routes.filter(o => o.parentViewID !== undefined && viewIDs.indexOf(o.parentViewID) !== -1);
    const groupedItems = AdministrationListUtils.groupByViewID(items);

    //console.log(`adminlist groupeditems: ${JSON.stringify(groupedItems)}`);

    return (
        <>
            <Paper sx={{
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                overflow: "hidden",
                overflowY: 'auto',
                backgroundColor: "custom.background.cardContainer"
                }}
                elevation={0}>

                {/* {viewIDs.map((o, index) => 
                    <AdministrationListItem key={index} adminViewID={o} />
                )} */}

                {groupedItems.map((o, index) => 
                    <AdministrationListItem key={index} item={o} />
                )}


                <AdministrationListItem headerInfo={{
                    title: t('helpMenu.help'),
                    icon: <HelpOutlined sx={{
                        marginTop: 'auto',
                        marginBottom: 'auto',
                        }} />

                    }}
                    //adminViewID = {-1}
                    item={undefined}
                    onClick={() => setHelpOpen(true)} />

            </Paper>

            <HelpMenu
                open={helpOpen}
                onClose={() => setHelpOpen(false)}
            />
      </>

    );
}

